import React from 'react';
import PropTypes from 'prop-types';
import { getUrl, getDescText, getPublishDate } from '../../common/services/builders';

function NSIRCSearchItem({ entry }) {
    return (
        <div className="search-result">
            <div className="row">
                <div className="small-6 column">
                    {renderTypeTag(entry)}
                </div>

            </div>
            <div className="row column">
                <h4><a href={getUrl(entry)}>{entry.title}</a></h4>
                <span dangerouslySetInnerHTML={{__html: getDescText(entry)}}></span>
                <span className="date">
                    <svg xmlns="http://www.w3.org/2000/svg" className="icon">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-clock"></use>
                    </svg>
                    {getPublishDate(entry)}
                </span>
            </div>
        </div>
    )
    
}

NSIRCSearchItem.propTypes = {
    entry: PropTypes.object,
};


function renderTypeTag(entry){
    if(entry.sys.contentTypeId == 'pressReleases'){
        var sectionType = "Press Release";

        var whichWebsite = entry.whichWebsiteToDisplayOn;
        //var sysUri = entry.sys.uri.toLowerCase();
        var contentTypes = [
            { path:"NSIRC_insights",sectionType:"Insight"},
            { path:"NSIRC_students",sectionType:"Student Profile"},
            { path:"NSIRC_dissertations",sectionType:"Dissertation"},
            { path:"NSIRC_theses",sectionType:"Thesis"},
            { path:"NSIRC_publications",sectionType:"Publication"},
            { path:"NSIRC_news",sectionType:"News"}
        ];

        contentTypes.forEach(function(element){
            if (whichWebsite.includes(element.path))
            {
                sectionType = element.sectionType;
            }                
        });

        return <span className="category--tag">{sectionType}</span>;
    }
    else if (entry.sys.dataFormat === "webpage") {
        
        return <span className="category--tag">Webpage</span>;
    }
    else
    {
        return <span className="category--tag">{entry.sys.contentTypeId.split(/(?=[A-Z])/).join(" ")}</span>;
    }
    
}


export default NSIRCSearchItem;